import carCode from './view/carCode.html'
import sharingGoods from './view/sharingGoods.html'
import utils from 'utils'
class carCodeComponent {
    constructor($scope, httpRequest, sweetalert, $state, logger, initSortService, $uibModal) {
        const scope = this
        scope.isAdmin = JSON.parse(localStorage.user_info).user.userType === 0 ? true : false
        scope.selectedArr = []
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                codeAndType: '',
                taxRate: '',
                status: '',
                vehicleTypeId: '',
            },
        }
        scope.reset = function () {
            $scope.queryParam.param = {
                codeAndType: '',
                taxRate: '',
                status: '',
                vehicleTypeId: '',
            }
        }
        // scope.reset()
        scope.exportParam = {
            accessToken: localStorage.id_token,
        }
        httpRequest.get_getLoginUserGoodsTypeList(1).then((res) => {
            scope.vehicleTypeList = res.data.value
        })
        // let taxRateArr = []
        httpRequest.get_queryGoodsTax({
            taxMergeCode: -1,
            invType: 12,
        }).then((res) => {
            scope.taxRateList = res.data.value
        })
        httpRequest.get_dictByTypeArr(['status', 'is_privilege', 'data_share']).then((res) => {
            scope.dictData = res.data.value
        })
        // let isSearch = false
        // $scope.$watch('queryParam', () => {
        //     isSearch = false
        // }, true)
        // $scope.$on('$stateChangeStart', (e, toState) => {
        //     if (toState.name.indexOf('outputManage.ovat.goodsInfo') != -1) {
        //         isSearch && sessionStorage.setItem('carCodeParam', JSON.stringify($scope.queryParam))
        //     }
        // })

        scope.queryList = function queryList() {
            $scope.queryParam = sessionStorage.carCodeParam ? JSON.parse(sessionStorage.carCodeParam) : $scope.queryParam
            const openLoading = $scope.queryParam.pageSize >= 100 ? window.layer.msg('正在查询，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            }) : null
            httpRequest.post_pageVehicleGood($scope.queryParam).then((res) => {
                scope.resData = res.data.value.list
                scope.totalItems = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
            }).finally(() => {
                window.layer.close(openLoading)
            })
            scope.exportParam = $.extend(scope.exportParam, $scope.queryParam.param, {
                selectedIdList: scope.selectedArr
            })
        }
        scope.searchlist = function searchlist() {
            sessionStorage.setItem('carCodeParam', JSON.stringify($scope.queryParam))
            scope.queryList()
        }
        scope.pageChanged = function () { // 点击页码发起查询
            sessionStorage.setItem('carCodeParam', JSON.stringify({
                orderMap: $scope.queryParam.orderMap,
                pageNum: $scope.queryParam.pageNum,
                pageSize: $scope.queryParam.pageSize,
                param: sessionStorage.carCodeParam ? JSON.parse(sessionStorage.carCodeParam).param : {
                    codeAndType: '',
                    taxRate: '',
                    status: '',
                    vehicleTypeId: '',
                },
            }, ))
            scope.queryList()
        }
        scope.queryList()
        scope.exportExel = function exportExel() {
            //httpRequest.get_exportAccount(scope.exportParam)
            let _url = `${host.etcloudOvat}settings/sysVehicleGood/exportToExcel?accessToken=${localStorage.getItem('id_token')}`
            for (let i in $scope.queryParam.orderMap) {
                scope.exportParam.sortField = i + ':' + $scope.queryParam.orderMap[i]
            }
            utils.post_downLoad(scope.exportParam, _url)
        }
        // 下拉配置
        scope.tableDropdownConfig = [{
            label: '编辑',
            handler(item) {
                const {
                    goodId
                } = item
                if (!goodId || goodId === 0) {
                    logger.logError('参数错误，请刷新重试')
                } else {
                    $state.go('outputManage.ovat.goodsInfo.EditCar', {
                        goodId
                    })
                }
            },
            showWhile(item, hasPermit) {
                return hasPermit('edit_goodsInfo') && (item.dataShare != 1 || scope.isAdmin)
            },
        }, {
            label: '删除',
            handler(item) {
                scope.delGoods(item.goodId)
            },
            showWhile(item, hasPermit) {
                return hasPermit('del_goodsInfo')
            },
        }, {
            label: '启用',
            handler(item) {
                scope.modGoodsStatus(item.goodId, item.status)
            },
            showWhile(item, hasPermit) {
                return hasPermit('edit_goodsInfo') && item.status === 0
            },
        }, {
            label: '禁用',
            handler(item) {
                scope.modGoodsStatus(item.goodId, item.status)
            },
            showWhile(item, hasPermit) {
                return hasPermit('edit_goodsInfo') && item.status === 1 && (item.dataShare != 1 || scope.isAdmin)
            },
        }, ]
        // 删除、批量删除
        scope.delGoods = function (id) {
            const selectedArr = id || id === 0 ? [id] : scope.selectedArr
            if (selectedArr.length > 0) {
                const msg = selectedArr.length > 1 ? '确认删除这些商品信息?' : '确认删除此商品信息?'
                sweetalert.confirm('删除提醒', msg).then(() => {
                    httpRequest.get_delVehicleGood({
                        idList: selectedArr
                    }).then((res) => {
                        if (res.data.success) scope.queryList()
                    })
                }, () => {

                })
            } else {
                logger.logError('请先选择商品')
            }
        }
        // 禁用启用
        scope.modGoodsStatus = function (vehicleGoodId, status) {
            // 弹出确认框
            const msg = status === 1 ? '确定要禁用此商品吗？' : '确定要启用此商品吗？'
            const title = status === 1 ? '禁用提醒' : '启用提醒'
            sweetalert.confirm(title, msg).then(() => {
                httpRequest.get_updateVehicleGoodStatus({
                    vehicleGoodId,
                    status: (status + 1) % 2,
                }).then(() => {
                    scope.queryList()
                })
            }, () => {

            })
        }
        // 导入配置
        scope.importconfig = {
            code: 'VEHICLE_GOOD',
            isSplit: true,
            validate: {
                pattern: '.xlsx,.xls,.txt',
                _validate: {
                    size: {
                        min: 10,
                        max: '10MB'
                    },
                    duration: {
                        min: '10s',
                        max: '5m'
                    },
                    accept: '.xlsx,.xls,.xml,.txt',
                },
            },
            callback() {
                // 回掉，可选
                scope.queryList()
            },
            appName: host.etcloudOvat,
            url: 'dlTaskService/import_VEHICLE_GOOD',
            downloadAppName: host.etcloudOvat,
        }
        // 新增
        scope.add = function add() {
            $state.go('outputManage.ovat.goodsInfo.addCar')
        }
        scope.managementClass = function managementClass() {
            $state.go('outputManage.ovat.goodsInfo.goodstype', {
                type: 1
            })
        }
        // 表头排序
        $scope.orderMap = initSortService('carCodeParam')
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('carCodeParam', JSON.stringify($scope.queryParam))
            scope.queryList()
        }
        $scope.shareGoods = function () {
            $uibModal.open({
                template: sharingGoods,
                openedClass: 'mod-modal mod-modal-hg',
                controller: 'sharingGoodsCtrl',
                animation: true,
                resolve: {
                    modalParams() {
                        return {
                            type: 1,
                            dictData: scope.dictData
                        }
                    },
                },
            }).result.then(() => {
                scope.queryList()
            })
        }
    }
}
carCodeComponent.$inject = ['$scope', 'httpRequest', 'sweetalert', '$state', 'logger', 'initSortService', '$uibModal']
export default angular
    .module('outputManage.ovat.goodsInfo.list', [])
    .controller('carCodeComponent', carCodeComponent)
    .component('carCode', {
        template: carCode,
        controller: 'carCodeComponent',
    }).name


// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/goodsInfo/carCodeComponent.js